import React from "react";
import styled from "styled-components";

import {
	lighten,
	darken,
} from "polished";

const getButtonTextColor = ({ theme, type, }) => (
	{
		CONFIRM: theme.colors.white,
		SELECT: theme.colors.white,
		CANCEL: theme.colors.white,
		WHITE: theme.colors.main,
	}[type]
);

const getButtonBackgroundColor = ({ theme, type, }) => (
	{
		CONFIRM: theme.colors.main,
		SELECT: lighten( 0.1, theme.colors.main, ),
		CANCEL: theme.colors.main,
		WHITE: theme.colors.white,
	}[type]
);

const ButtonStyled = styled.div`
	background-color: ${getButtonBackgroundColor};
	color: ${getButtonTextColor};
	cursor: pointer;
	display: inline-block;
	font-weight: bold;
	margin: 4px;
	padding: 4px;
	position: relative;
	text-align: center;
	text-transform: uppercase;
	transition: 0.1s all linear;

	&:hover,
	&:active {
		background-color: ${ (p) => darken(
			0.2,
			getButtonBackgroundColor(p)
		)}
	}
`;

const Button = (props) => (
	<ButtonStyled 
		type = { props.type }
		onClick = { props.onClick }
	>
		{ props.text || props.children }
	</ButtonStyled>
);

Button.propTypes = {
	children: React.PropTypes.oneOfType([
		React.PropTypes.string,
		React.PropTypes.element,
	]),
	onClick: React.PropTypes.func.isRequired,
	type: React.PropTypes.oneOf([
		"SELECT",
		"CONFIRM",
		"CANCEL",
		"WHITE",
	]),
	fullWidth: React.PropTypes.bool,
	text: React.PropTypes.string,
	active: React.PropTypes.bool,
};

export default Button;
